import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantContext } from "@/contexts/RestaurantContext";
import { toast } from "sonner";

export function useCouvert() {
  const { activeRestaurant, refetch } = useRestaurantContext();
  const [isUpdating, setIsUpdating] = useState(false);

  const couvertEnabled = Boolean((activeRestaurant as any)?.couvert_enabled ?? false);
  const couvertPrice = Number((activeRestaurant as any)?.couvert_price ?? 0);

  const updateCouvert = async (enabled: boolean, price: number) => {
    if (!activeRestaurant) return false;

    setIsUpdating(true);
    try {
      const { error } = await supabase
        .from("restaurants")
        .update({
          couvert_enabled: enabled,
          couvert_price: price,
        })
        .eq("id", activeRestaurant.id);

      if (error) throw error;

      await refetch();
      toast.success("Couvert atualizado!");
      return true;
    } catch (error) {
      console.error("Error updating couvert:", error);
      toast.error("Erro ao atualizar couvert");
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  const calculateCouvert = useCallback(
    (quantity: number): number => {
      if (!couvertEnabled || quantity <= 0) return 0;
      return couvertPrice * quantity;
    },
    [couvertEnabled, couvertPrice]
  );

  return {
    couvertEnabled,
    couvertPrice,
    updateCouvert,
    calculateCouvert,
    isUpdating,
  };
}
